<template>
  <Link :icon="icon" :disabled="disabled" :loading="loading" :type="type" :hoverable-title="hoverableTitle" @click="onClick">
    <slot />
  </Link>
</template>
<script setup lang="ts">
import Link from './Link.vue';
import { useModal } from '../../modal/useModal';

export interface MenuItem {
  component: any;
  icon?: string;
  disabled?: boolean;
  loading?: boolean;
  type?: string;
  hoverableTitle?: boolean;
}

const props = defineProps<MenuItem>();

const onClick = (e: PointerEvent) => {
  e && e.stopPropagation();
  e && e.preventDefault();

  const { open } = useModal(props.component);
  open();
};
</script>
<style></style>
